import Headroom from 'headroom.js'
import { header } from './_constants'

export default function initHeadroom() {
  const headroom = new Headroom(header, {
    offset: 32,
    tolerance: {
      up: 200,
      down: 0,
    },
  })

  headroom.init()
}
